// FilterModal.tsx
import React from "react";
import styles from './FilterSection.module.css';
import CategoryPicker from './CategoryPicker';
import PeriodPicker from './PeriodPicker';
import { LocateMe } from './LocateMe';
import { useSharedState } from '../hooks/useSharedState';

export const FilterModal: React.FC<{ hide: () => void }> = ({ hide }) => {
  const [categories, setCategories] = useSharedState('categories', '');
  const [free, setFree] = useSharedState('free', '');

  const toggleFree = () => setFree(free === '1' ? '0' : '1');

  return (
    <div className={styles.filterExpanded}>
      <h1>Filtres</h1>
      <CategoryPicker
        selectedCategories={categories.split(';')}
        onChange={(cats) => setCategories(cats.join(';'))}
      />
      <LocateMe />
      <button
        type="button"
        className={[styles.freeButton, free === '1' ? styles.selected : ''].join(' ')}
        onClick={toggleFree}
      >
        Gratuit {free === '1' && <>✓</>}
      </button>
      <PeriodPicker />
      <button className={styles.filterCollapseBtn} onClick={hide}>Fermer</button>
    </div>
  );
};
